import classnames from 'classnames';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';
import styles from './textArea.module.scss';

interface TextAreaProps
  extends Partial<
    React.DetailedHTMLProps<
      React.TextareaHTMLAttributes<HTMLTextAreaElement>,
      HTMLTextAreaElement
    >
  > {
  label?: string;
  error?: string | null;
  register: UseFormRegisterReturn;
}

const TextArea = ({
  label,
  error,
  register,
  required,
  className,
  ...textAreaProps
}: TextAreaProps) => {
  return (
    <div className={'form-group'}>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      <textarea
        {...register}
        className={classnames('form-control', styles.textArea, className)}
        aria-label={register.name}
        {...textAreaProps}
      ></textarea>
    </div>
  );
};

export default TextArea;
